module.exports = __webpack_public_path__ + "img/gzbgs.3b15a2ac.jpg";